import type { CSSProperties, ReactNode } from 'react';
import { RequiredAsterisk } from './RequiredAsterisk';

/**
 * Form-field title used across Logiblocks node customization panels.
 * Pass `required` to append a red asterisk in the standard form-marker style.
 */
export const FieldLabel = ({
  required,
  children,
  className,
  style,
}: {
  required?: boolean;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) => (
  <label className={className} style={style}>
    {children}
    {required && <RequiredAsterisk marginLeft={4} />}
  </label>
);
